import Vue from 'vue'
import yxqnAlert from './yxqnAlert.vue'

let newInstance = null
// 将vue组件进行构造函数转换
const ConfirmConstructor = Vue.extend(yxqnAlert)
const init = (options) => {
// 将组件实例化
  newInstance = new ConfirmConstructor({
    el: document.createElement('div')
  })
  // 加载dom
  document.body.appendChild(newInstance.$el)
}
export const ALERT_TYPE = {
  ALERT: 'alert',
  CONFIRM: 'confirm'
}
const caller = (type, content, options) => {
  // options 调用时传入配置项
  // console.log(options)
  // console.log(newInstance)
  if (!newInstance) {
    init(options)
  }
  for (const prop in options) {
    if (options.hasOwnProperty(prop)) {
      newInstance[prop] = options[prop]
    }
  }
  newInstance.ALERT_TYPE = ALERT_TYPE
  newInstance.dialogType = type
  newInstance.content = content || ''
  Vue.nextTick(() => {
    newInstance.open = true
  })
  return newInstance.show(options)
}
export default {
  install (vue) {
    vue.prototype.$yxqnAlert = caller.bind(null, ALERT_TYPE.ALERT)
    vue.prototype.$yxqnConfirm = caller.bind(null, ALERT_TYPE.CONFIRM)
  }
}
